import { getBoxShadowAsList } from './get-box-shadow-as-list';

export function getBoxShadow(rawShadow: any[]): string {
	return getBoxShadowAsList(rawShadow).join(',');
}
